var currentStep = 1;
var selectedDrawings = {};
var selectedSpecs = {};
var selectedContacts = [];

function InitOrdering() {
	if (project.ProjectStatus.toLowerCase() == "busy" && !settings.IsDocumentClerk) {
		showInfoDialogPWall('Project Busy', 'This project is currently undergoing maintenance.  Documents may not be ordered at this time.');
		return;
	}

	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'Ordering', {
		isOldModule: true,
		isJsRender: true
	}), $('#pjq-ordering'), null, function () {
		//IE fix for Object.keys
		if (!Object.keys) {
			Object.keys = function (obj) {
				var keys = [],
					key;

				for (key in obj) {
					if (obj.hasOwnProperty(key)) {
						keys.push(key);
					}
				}

				return keys;
			};
		}
		if (settings.OrderDefLFPrintSize.toLowerCase() == 'full size') {
			jQuery('#orderDrawingsQuantityFull').val(settings.OrderDefLFQty);
			jQuery('#orderDrawingsQuantityHalf').val(0);
		}
		else if (settings.OrderDefLFPrintSize.toLowerCase() == 'half size') {
			jQuery('#orderDrawingsQuantityHalf').val(settings.OrderDefLFQty);
			jQuery('#orderDrawingsQuantityFull').val(0);
		}
		jQuery('#orderSpecsQuantity').val(settings.OrderDefSFQty);
		//jQuery('#orderCDQuantity').val(settings.OrderDefCDQty);
		var lfBinding = settings.OrderDefLFBinding;
		if (lfBinding.toLowerCase() == 'binding edge') {
			lfBinding = 'B-EDGE';
		}
		else if (lfBinding.toLowerCase() == 'punch and bind') {
			lfBinding = 'B-PBND';
		}
		jQuery('#orderDrawingsBindingType').val(lfBinding);
		jQuery('#orderDrawingsPaperType').val(settings.OrderDefLFPaper);
		jQuery('#orderDrawingsPaperSize').val(settings.OrderDefLFPrintSize);
		var sfBinding = settings.OrderDefSFBinding;
		if (sfBinding.toLowerCase() == 'gbc') {
			sfBinding = 'B-GBC';
		}
		else if (sfBinding.toLowerCase() == 'chicago screw') {
			sfBinding = 'B-CSCW';
		}
		jQuery('#orderSpecsBindingType').val(sfBinding);
		jQuery('#orderSpecsPaperType').val(settings.OrderDefSFPaper);
		jQuery('#orderDocumentsBillingShippingGlobal').val(settings.OrderDefDeliverBy);
		jQuery('.orderingButtonContainer button').button();
		jQuery('.orderOptionsButtonContainer button').button();
		InitDrawingsSelectGrid();
		InitSpecsSelectGrid();
		PanteraScript.PanteraScriptService.GetProjectFolders(pjqSessionId, project.ProjectId, GetProjectFoldersC, onScriptError);
		jQuery('#pjq-ordering').after("<div id='ordering-loading' style='text-align:center;'><img src='/i/ajax-loader.gif' alt='Loading...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>Loading...</span></div>");
		jQuery('#pjq-main').hide();
	});
}

var projectFolders = null;

function GetProjectFoldersC(response) {
	projectFolders = jQuery.parseJSON(response);
	for (var f = 0; f < projectFolders.length; f++) {
		var isChecked = false;
		var folderTitle = projectFolders[f].Title;
		if (folderTitle.indexOf(')') != -1) {
			folderTitle = folderTitle.substring(folderTitle.indexOf(')') + 1, folderTitle.length);
		}
		if (f == 0) {
			jQuery('#orderFolderButtonset').append('<input type="radio" name="orderFolderButtonset" checked="checked" id="pFolder_' + projectFolders[f].EntryId + '"></input><label for="pFolder_' + projectFolders[f].EntryId + '">' + folderTitle + '</label>')
		}
		else {
			jQuery('#orderFolderButtonset').append('<input type="radio" name="orderFolderButtonset" id="pFolder_' + projectFolders[f].EntryId + '"></input><label for="pFolder_' + projectFolders[f].EntryId + '">' + folderTitle + '</label>')
		}

	}
	jQuery('#orderFolderButtonset').buttonset();
	jQuery('#orderFolderButtonset').find('label').css('display', 'block');
	RefreshFileSelectGrid(jQuery('#orderFolderButtonset').find('input:checked'), false);
	jQuery('#orderFolderButtonset input').on('click', function () {
		RefreshFileSelectGrid(jQuery(this), true);
	});
}

function RefreshFileSelectGrid(button, isClear) {
	var entryId = button.attr('id').replace('pFolder_', '');
	jQuery('#drawingsSelectGridHeader').find('p').text(jQuery('label[for="' + button.attr('id') + '"]').find('span').text());
	UpdateSelectedFileArr();
	if (isClear) {
		drawingsSelectGrid.clearAndLoad("/DesktopModules/PJQProjectWallAdmin/GetOrderingGrid.aspx?sessionId=" + pjqSessionId + '&id=' + entryId + '&grid=drawings', 'xml');
		specsSelectGrid.clearAndLoad("/DesktopModules/PJQProjectWallAdmin/GetOrderingGrid.aspx?sessionId=" + pjqSessionId + '&id=' + entryId + '&grid=specs', 'xml');
	}
	else {
		drawingsSelectGrid.load("/DesktopModules/PJQProjectWallAdmin/GetOrderingGrid.aspx?sessionId=" + pjqSessionId + '&id=' + entryId + '&grid=drawings', 'xml');
		specsSelectGrid.load("/DesktopModules/PJQProjectWallAdmin/GetOrderingGrid.aspx?sessionId=" + pjqSessionId + '&id=' + entryId + '&grid=specs', 'xml');
	}
}

function CheckSelectedDocuments() {
	drawingsSelectGrid.uncheckAll();
	for (var cd = 0; cd < drawingsSelectGrid.getRowsNum(); cd++) {
		if (typeof selectedDrawings[parseInt(drawingsSelectGrid.getRowId(cd))] != 'undefined') {
			drawingsSelectGrid.cells2(cd, 0).setValue(1);
		}
		else {
			drawingsSelectGrid.cells2(cd, 0).setValue(0);
		}
	}
	if (Object.keys(selectedDrawings).length == drawingsSelectGrid.getRowsNum()) {
		jQuery('#drawingsSelectAll').prop('checked', true);
	}
	else {
		jQuery('#drawingsSelectAll').prop('checked', false);
	}
	specsSelectGrid.uncheckAll();
	for (var cs = 0; cs < specsSelectGrid.getRowsNum(); cs++) {
		if (typeof selectedSpecs[parseInt(specsSelectGrid.getRowId(cs))] != 'undefined') {
			specsSelectGrid.cells2(cs, 0).setValue(1);
		}
		else {
			specsSelectGrid.cells2(cs, 0).setValue(0);
		}
	}
	if (Object.keys(selectedSpecs).length == specsSelectGrid.getRowsNum()) {
		jQuery('#specsSelectAll').prop('checked', true);
	}
	else {
		jQuery('#specsSelectAll').prop('checked', false);
	}
}

function OrderingContinue() {
	if (currentStep == 1) {
		UpdateSelectedFileArr();
		if (!addressBookInit) {
			InitAddressBook();
		}
		jQuery('#orderSelectedDocumentsList').empty();
		if (Object.keys(selectedDrawings).length) {
			PanteraScript.PanteraScriptService.GetEntriesByEntryIdList(jQuery.map(selectedDrawings, function (e, key) {
				return key;
			}).join(), 'drawings', GetEntriesByEntryIdListC, onScriptError);
		}
		if (Object.keys(selectedSpecs).length) {
			PanteraScript.PanteraScriptService.GetEntriesByEntryIdList(jQuery.map(selectedSpecs, function (e, key) {
				return key;
			}).join(), 'specs', GetEntriesByEntryIdListC, onScriptError);
		}

		jQuery('#selectedDocumentsCount').text(Object.keys(selectedDrawings).length + Object.keys(selectedSpecs).length);
		jQuery('.orderOptions').hide();
		jQuery('.folderSelectContainer').hide();
		jQuery('.orderStep1Header').hide();
		jQuery('#orderStep1').hide();
		jQuery('.orderSelectedDocuments').show();
		jQuery('.orderStep2Header').show();
		jQuery('#orderStep2').show();
		CheckSelectedDocuments();
	}
	else if (currentStep == 2) {
		CalculateOrder();
		jQuery('.orderOptions').show();
		jQuery('.orderStep2Header').hide();
		jQuery('#orderStep2').hide();
		jQuery('.orderStep3Header').show();
		jQuery('#orderStep3').show();
		jQuery('.orderSelectedDocuments').hide();
		jQuery('.orderBillingOptions').show();
		jQuery('#orderingContinue').hide();
		jQuery('#orderingSubmitOrder').show();

		if (Object.keys(selectedDrawings).length == 0) {
			jQuery('.orderDrawingsOptions').hide();
			jQuery('.orderDrawingsOptionsDocCount').text('');
		}
		else {
			jQuery('.orderDrawingsOptions').show();
			jQuery('.orderDrawingsOptionsDocCount').text(" (" + Object.keys(selectedDrawings).length + ")");
		}

		if (Object.keys(selectedSpecs).length == 0) {
			jQuery('.orderSpecsOptions').hide();
			jQuery('.orderSpecsOptionsDocCount').text('');
		}
		else {
			jQuery('.orderSpecsOptions').show();
			jQuery('.orderSpecsOptionsDocCount').text(" (" + Object.keys(selectedSpecs).length + ")");
		}
	}
	currentStep++;
	CheckCanContinue();
}

function OrderingBack(isNew) {
	if (isNew) {
		addressBookInit = false;
		selectedDrawings = {};
		selectedSpecs = {};
		selectedContacts = [];
		orderArr = {};
		jQuery('.orderOptions').hide();
		jQuery('.orderStep2Header').show();
		jQuery('#orderStep2').show();
		jQuery('.orderStep3Header').hide();
		jQuery('#orderStep3').hide();
		jQuery('.orderSelectedDocuments').show();
		jQuery('.orderBillingOptions').hide();
		jQuery('.orderDocumentsBillingItems').find('tr').remove();
		jQuery('#orderingSubmitOrder').hide();
		jQuery('#orderingContinue').show();
		CheckSelectedDocuments();
	}
	if (currentStep == 1) {
		addressBookInit = false;
		selectedDrawings = {};
		selectedSpecs = {};
		selectedContacts = [];
		orderArr = {};
		jQuery('#pjq-ordering').empty();
		jQuery('#pjq-main').show();
	}
	else if (currentStep == 2) {
		jQuery('.orderSelectedDocuments').hide();
		jQuery('.orderStep2Header').hide();
		jQuery('#orderStep2').hide();
		jQuery('.orderOptions').show();
		jQuery('.folderSelectContainer').show();
		jQuery('.orderStep1Header').show();
		jQuery('#orderStep1').show();
		orderArr = {};
	}
	else if (currentStep == 3) {
		UpdateSelectedContacts();
		jQuery('.orderOptions').hide();
		jQuery('.orderStep2Header').show();
		jQuery('#orderStep2').show();
		jQuery('.orderStep3Header').hide();
		jQuery('#orderStep3').hide();
		jQuery('.orderSelectedDocuments').show();
		jQuery('.orderBillingOptions').hide();
		jQuery('.orderDocumentsBillingItems').find('tr').remove();
		jQuery('#orderingSubmitOrder').hide();
		jQuery('#orderingContinue').show();
	}
	if (currentStep != 1) {
		currentStep--;
	}
	CheckCanContinue();
}

function GetEntriesByEntryIdListC(response) {
	var entryResponse = jQuery.parseJSON(response);
	if (entryResponse.Type == 'drawings') {
		for (var sf = 0; sf < projectFolders.length; sf++) {
			if (jQuery('#selectedSpecsHeader').length > 0) {
				jQuery('#selectedSpecsHeader').before('<div style="display:none;margin-bottom:10px;" id="selectedDocFolder_' + projectFolders[sf].EntryId + '"><table style="width:100%;table-layout:fixed;"></table></div>');
			}
			else {
				jQuery('#orderSelectedDocumentsList').append('<div style="display:none;margin-bottom:10px;" id="selectedDocFolder_' + projectFolders[sf].EntryId + '"><table style="width:100%;table-layout:fixed;"></table></div>');
			}
			var folderTitle = projectFolders[sf].Title;
			if (folderTitle.indexOf(')') != -1) {
				folderTitle = folderTitle.substring(folderTitle.indexOf(')') + 1, folderTitle.length);
			}
			jQuery('#selectedDocFolder_' + projectFolders[sf].EntryId).prepend('<div style="font-weight:bold;font-size:16px;text-decoration:underline;">' + folderTitle + '</div>');
		}
		for (var sd = 0; sd < entryResponse.Entries.length; sd++) {
			jQuery('#selectedDocFolder_' + entryResponse.Entries[sd].CollectionId + ' table').append('<tr><td title="' + entryResponse.Entries[sd].Title + '" style="max-width:80%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;">' + entryResponse.Entries[sd].Title + '</td><td style="width:20%;text-align:center;"><button type="button" id="selectedDrawing_' + entryResponse.Entries[sd].EntryId + '" class="removeSelectedDocumentButton" onclick="RemoveSelectedDocuments(jQuery(this))"></button></td></tr>');
			jQuery('#selectedDocFolder_' + entryResponse.Entries[sd].CollectionId).show();
		}
	}
	else if (entryResponse.Type == 'specs') {
		jQuery('#orderSelectedDocumentsList').append('<div id="selectedSpecsHeader" style="font-weight:bold;font-size:16px;text-decoration:underline;">Specs</div><div style="display:none;margin-bottom:10px;" id="selectedSpecsFolder"><table style="width:100%;table-layout:fixed;"></table></div>');
		for (var sd = 0; sd < entryResponse.Entries.length; sd++) {
			jQuery('#selectedSpecsFolder table').append('<tr><td title="' + entryResponse.Entries[sd].Title + '" style="max-width:80%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;">' + entryResponse.Entries[sd].Title + '</td><td style="width:30%;text-align:center;"><button type="button" id="selectedSpec_' + entryResponse.Entries[sd].EntryId + '" class="removeSelectedDocumentButton" onclick="RemoveSelectedDocuments(jQuery(this))"></button></td></tr>');
			jQuery('#selectedSpecsFolder').show();
		}
	}
	jQuery('#orderSelectedDocumentsList button').button({
		icons: {
			primary: 'ui-icon-close'
		}
	});
}

function UpdateSelectedFileArr() {
	for (var d = 0; d < drawingsSelectGrid.getRowsNum(); d++) {
		if (drawingsSelectGrid.cells2(d, 0).getValue() == '1') {
			selectedDrawings[drawingsSelectGrid.getRowId(d)] = drawingsSelectGrid.cells2(d, 1).getValue();
		}
		else if (typeof selectedDrawings[drawingsSelectGrid.getRowId(d)] != 'undefined') {
			delete selectedDrawings[drawingsSelectGrid.getRowId(d)];
		}
	}
	for (var s = 0; s < specsSelectGrid.getRowsNum(); s++) {
		if (specsSelectGrid.cells2(s, 0).getValue() == '1') {
			selectedSpecs[specsSelectGrid.getRowId(s)] = specsSelectGrid.cells2(s, 1).getValue();
		}
		else if (typeof selectedSpecs[specsSelectGrid.getRowId(s)] != 'undefined') {
			delete selectedSpecs[specsSelectGrid.getRowId(s)];
		}
	}
}

function RemoveSelectedDocuments(buttonObj) {
	var thisEntryId = 0;
	if (buttonObj.attr('id').indexOf('selectedDrawing_') != -1) {
		thisEntryId = parseInt(buttonObj.attr('id').replace('selectedDrawing_', ''));
		if (typeof selectedDrawings[thisEntryId] != 'undefined') {
			delete selectedDrawings[thisEntryId];

		}
	}
	else if (buttonObj.attr('id').indexOf('selectedSpec_') != -1) {
		thisEntryId = parseInt(buttonObj.attr('id').replace('selectedSpec_', ''));
		if (typeof selectedSpecs[thisEntryId] != 'undefined') {
			delete selectedSpecs[thisEntryId];

		}
	}
	CheckSelectedDocuments();
	if (Object.keys(selectedDrawings).length == 0 && Object.keys(selectedSpecs).length == 0) {
		OrderingBack();
	}
	else {
		buttonObj.closest('tr').remove();
		jQuery('#selectedDocumentsCount').text(Object.keys(selectedDrawings).length + Object.keys(selectedSpecs).length);
	}
}

var drawingsSelectGridMenu = null;
var drawingsSelectGrid = null;

function InitDrawingsSelectGrid() {

	/*
	drawingsSelectGridMenu = new dhtmlXMenuObject('gridMenu');
	drawingsSelectGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	drawingsSelectGridMenu.renderAsContextMenu();
	drawingsSelectGridMenu.attachEvent("onClick", function(id, zoneId) {
	  onGridMenuButtonClick(drawingsSelectGrid, zoneId, id);
	});
	drawingsSelectGridMenu.loadXMLString(CreateGridMenuXMLString(true, true, true));
	*/

	drawingsSelectGrid = new dhtmlXGridObject('drawingsSelectGrid');
	drawingsSelectGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	drawingsSelectGrid.setSkin(pjqGridTheme);
	drawingsSelectGrid.enableAutoHeight(true);
	drawingsSelectGrid.enableAutoWidth(true);
	drawingsSelectGrid.setDelimiter('|');
	//drawingsSelectGrid.enableContextMenu(drawingsSelectGridMenu);
	drawingsSelectGrid.init();
	drawingsSelectGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#ordering-loading').remove();
		if (drawingsSelectGrid.getRowsNum() > 0) {
			CheckSelectedDocuments();
			jQuery('#drawingsSelectGrid').show();
			jQuery('#drawingsSelectGridHeader').show();
		}
		else {

			jQuery('#drawingsSelectGrid').hide();
			jQuery('#drawingsSelectGridHeader').hide();
		}
		jQuery('#pjq-ordering').show();
	});
	drawingsSelectGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		InitDrawingViewer(rId);
	});
	drawingsSelectGrid.attachEvent("onEditCell", function (stage, id, ind, newVal, oldVal) {
		CheckCanContinue();
		return true;
	});

	drawingsSelectGrid.attachEvent("onCheckbox", function (row, ind, state) {
		CheckCanContinue();
		if (!state) {
			var master = this.hdr.rows[1].cells[ind].getElementsByTagName("INPUT")[0];
			master.checked = false;
		}
		return true;
	});

	/*
	drawingsSelectGrid.attachEvent("onBeforeContextMenu", function(id, ind, obj) {
	  drawingsSelectGrid.selectRowById(id, false, false, true);
	  return true;
	});
	*/
	dhtmlXGridObject.prototype._in_header_master_checkbox_dr = function (a, b, c) {
		a.innerHTML = c[0] + "<input type='checkbox' id='drawingsSelectAll' />" + c[1];
		var d = this;
		a.getElementsByTagName("input")[0].onclick = function (a) {
			d._build_m_order();
			var c = d._m_order ? d._m_order[b] : b, g = this.checked ? 1 : 0;
			d.forEachRowA(function (a) {
				var b = this.cells(a, c);
				if (b.isCheckbox() && !b.isDisabled()) b.setValue(g), b.cell.wasChanged = !0;
				this.callEvent("onEditCell", [1, a, c, g]);
				this.callEvent("onCheckbox", [a, c, g])
			});
			CheckCanContinue();

			(a || event).cancelBubble = !0;
		}
	};

}

var specsSelectGridMenu = null;
var specsSelectGrid = null;

function InitSpecsSelectGrid() {

	/*
	specsSelectGridMenu = new dhtmlXMenuObject('gridMenu');
	specsSelectGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	specsSelectGridMenu.renderAsContextMenu();
	specsSelectGridMenu.attachEvent("onClick", function(id, zoneId) {
	  onGridMenuButtonClick(drawingsSelectGrid, zoneId, id);
	});
	specsSelectGridMenu.loadXMLString(CreateGridMenuXMLString(true, true, true));
	*/

	specsSelectGrid = new dhtmlXGridObject('specsSelectGrid');
	specsSelectGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	specsSelectGrid.setSkin(pjqGridTheme);
	specsSelectGrid.enableAutoHeight(true);
	specsSelectGrid.enableAutoWidth(true);
	specsSelectGrid.setDelimiter('|');
	//specsSelectGrid.enableContextMenu(drawingsSelectGridMenu);
	specsSelectGrid.init();
	specsSelectGrid.attachEvent("onXLE", function (grid_obj, count) {
		jQuery('#ordering-loading').remove();
		if (specsSelectGrid.getRowsNum() > 0) {
			CheckSelectedDocuments();
			jQuery('#specsSelectGrid').show();
			jQuery('#specsSelectGridHeader').show();
		}
		else {

			jQuery('#specsSelectGrid').hide();
			jQuery('#specsSelectGridHeader').hide();
		}
		jQuery('#pjq-ordering').show();
	});
	specsSelectGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		InitDrawingViewer(rId);
	});
	specsSelectGrid.attachEvent("onEditCell", function (stage, id, ind, newVal, oldVal) {
		CheckCanContinue();
		return true;
	});

	specsSelectGrid.attachEvent("onCheckbox", function (row, ind, state) {
		CheckCanContinue();
		if (!state) {
			var master = this.hdr.rows[1].cells[ind].getElementsByTagName("INPUT")[0];
			master.checked = false;
		}
		return true;
	});

	/*
	specsSelectGrid.attachEvent("onBeforeContextMenu", function(id, ind, obj) {
	  drawingsSelectGrid.selectRowById(id, false, false, true);
	  return true;
	});
	*/
	dhtmlXGridObject.prototype._in_header_master_checkbox_sp = function (a, b, c) {
		a.innerHTML = c[0] + "<input type='checkbox' id='specsSelectAll' />" + c[1];
		var d = this;
		a.getElementsByTagName("input")[0].onclick = function (a) {
			d._build_m_order();
			var c = d._m_order ? d._m_order[b] : b, g = this.checked ? 1 : 0;
			d.forEachRowA(function (a) {
				var b = this.cells(a, c);
				if (b.isCheckbox() && !b.isDisabled()) b.setValue(g), b.cell.wasChanged = !0;
				this.callEvent("onEditCell", [1, a, c, g]);
				this.callEvent("onCheckbox", [a, c, g])
			});
			CheckCanContinue();

			(a || event).cancelBubble = !0;
		}
	};

}

function CheckCanContinue() {
	var canContinue = false;
	var grid = null;
	if (currentStep == 1) {
		if (drawingsSelectGrid != null) {
			if (drawingsSelectGrid.getCheckedRows(0).length > 0) {
				canContinue = true;
			}
		}
		if (specsSelectGrid != null) {
			if (specsSelectGrid.getCheckedRows(0).length > 0) {
				canContinue = true;
			}
		}
	}
	else if (currentStep == 2) {
		if (gridMain != null) {
			if (gridMain.getCheckedRows(0).length > 0) {
				canContinue = true;
			}
		}
	}


	if (canContinue) {
		jQuery('#orderingContinue').button('enable');
	}
	else {
		jQuery('#orderingContinue').button('disable');
	}
}

function InitDrawingViewer(id) {
	ViewDoc(id, 0, PJQ.app.session.project.get('masterUserId'), PJQ.app.session.get('portalId'));
}

function CalculateOrder() {
	jQuery('#orderDocumentsBillingLoading').show();
	var shippingSpeed = '';
	for (var c = 0; c < selectedContacts.length; c++) {
		PanteraScript.PanteraScriptService.CalculateOrder(pjqSessionId, selectedContacts[c], jQuery.map(selectedDrawings, function (e, key) {
			return key;
		}).join(), jQuery.map(selectedSpecs, function (e, key) {
			return key;
		}).join(), jQuery('#orderDocumentsBillingShippingGlobal').val(), jQuery('#orderDrawingsBindingType').val(), jQuery('#orderDrawingsPaperType').val(), jQuery('#orderSpecsBindingType').val(), jQuery('#orderSpecsPaperType').val(), false, false, parseInt(jQuery('#orderDrawingsQuantityFull').val()), parseInt(jQuery('#orderSpecsQuantity').val()), parseInt(jQuery('#orderDrawingsQuantityHalf').val()), parseInt(jQuery('#orderCDQuantity').val()), true, CalculateOrderC, onScriptError);
	}
	jQuery('#orderTotals').show();
	jQuery('.orderItemDelete').button({
		icons: {
			primary: 'ui-icon-trash'
		}
	});
	jQuery('.orderItemContactEditAddressBtn').button();
	jQuery('#orderDocumentsBillingLoading').hide();
	jQuery('.orderDocumentsBillingItems').show();
}

var orderArr = {};

function CalculateOrderC(response) {
	var orderResponse = jQuery.parseJSON(response);
	CreateOrderItemUI(orderResponse.ContactId);
	UpdateOrderC(response);
}

function UpdateOrderContact(response) {
	var orderResponse = jQuery.parseJSON(response);
	var orderItemContainer = jQuery('#orderItem_' + orderResponse.ContactId);
	orderItemContainer.find('.orderItemCompanyName').text(orderResponse.CompanyName);
	orderItemContainer.find('.orderItemContactName').text(orderResponse.ContactName);
	orderItemContainer.find('.orderItemContactAddress1').text(orderResponse.Address1);
	orderItemContainer.find('.orderItemContactAddress2').text(orderResponse.Address2);
	orderItemContainer.find('.orderItemContactCity').text(orderResponse.City);
	orderItemContainer.find('.orderItemContactState').text(orderResponse.State);
	orderItemContainer.find('.orderItemContactZip').text(orderResponse.Zip);
	orderItemContainer.find('.orderItemContactCountry').text(orderResponse.Country);
	orderItemContainer.find('.orderItemContactPhone').text(orderResponse.Phone);
}

function CalculateOrderTotal() {
	var orderSubtotal = 0;
	var orderTax = 0;
	var orderShipping = 0;
	var orderSurcharge = 0;
	var orderTotal = 0;
	for (var order in orderArr) {
		if (!orderArr[order].IsCalculateError) {
			orderSubtotal += orderArr[order].Subtotal;
			orderTax += orderArr[order].Tax;
			orderShipping += orderArr[order].Shipping;
			orderSurcharge += orderArr[order].Surcharge;
			orderTotal += orderArr[order].Total;
		}
	}
	jQuery('#orderSubtotal').text('$' + orderSubtotal.toFixed(2));
	jQuery('#orderTax').text('$' + orderTax.toFixed(2));
	jQuery('#orderShipping').text('$' + orderShipping.toFixed(2));
	jQuery('#orderSurcharge').text('$' + orderSurcharge.toFixed(2));
	jQuery('#orderTotal').text('$' + orderTotal.toFixed(2));
}

function CreateOrderItemUI(contactId) {
	jQuery('.orderDocumentBillingRowTemplate .orderItemRow').clone().appendTo(jQuery('.orderDocumentsBillingItems>tbody')).attr('id', 'orderItem_' + contactId);
	//jQuery('#orderItem_' + contactId).find('.orderItemBillingShipping').attr('id', 'orderItemShipping_' + contactId);
	//jQuery('#orderItemShipping_' + contactId).val(settings.OrderDefDeliverBy);
	jQuery('#orderItem_' + contactId).find('.orderItemContactEditAddressBtn').attr('onclick', 'InitEditContactAddressDialogHelper(jQuery(this))');
	/*
	jQuery('#orderItemShipping_' + contactId).on('change',function(){
	  UpdateOrder(jQuery(this).attr('id').replace('orderItemShipping_', ''));
	})
	*/
	jQuery('.orderItemShippingMethod').val(jQuery('#orderDocumentsBillingShippingGlobal').val());
	jQuery('#orderDocumentsBillingShippingGlobal').on('change', function () {
		jQuery('.orderItemShippingMethod').val(jQuery(this).val());
	})

}

function UpdateOrderHelper(contactId) {
	UpdateOrder(contactId);
	jQuery('#editContactAddressDialog').dialog('close');
}

function UpdateSaturdayDelivery() {
	if (jQuery('#orderSaturdayDelivery').prop('checked')) {
		jQuery('#orderDocumentsBillingShippingGlobal').val('Next Day (Standard)').prop('disabled', true);
	}
	else {
		jQuery('#orderDocumentsBillingShippingGlobal').val(settings.OrderDefDeliverBy).prop('disabled', false);
	}
	UpdateOrdersAll();
}

function UpdateOrdersAll() {
	for (var oa = 0; oa < selectedContacts.length; oa++) {
		UpdateOrder(selectedContacts[oa]);
	}
}

function UpdateOrder(contactId) {
	PanteraScript.PanteraScriptService.CalculateOrder(pjqSessionId, contactId, jQuery.map(selectedDrawings, function (e, key) {
		return key;
	}).join(), jQuery.map(selectedSpecs, function (e, key) {
		return key;
	}).join(), jQuery('#orderDocumentsBillingShippingGlobal').val(), jQuery('#orderDrawingsBindingType').val(), jQuery('#orderDrawingsPaperType').val(), jQuery('#orderSpecsBindingType').val(), jQuery('#orderSpecsPaperType').val(), jQuery('#orderSaturdayDelivery').prop('checked'), false, parseInt(jQuery('#orderDrawingsQuantityFull').val()), parseInt(jQuery('#orderSpecsQuantity').val()), parseInt(jQuery('#orderDrawingsQuantityHalf').val()), parseInt(jQuery('#orderCDQuantity').val()), false, UpdateOrderC, onScriptError);
}

function UpdateOrderC(response) {
	var orderResponse = jQuery.parseJSON(response);
	UpdateOrderContact(response);
	orderArr[orderResponse.ContactId] = orderResponse;
	var orderItemContainer = jQuery('#orderItem_' + orderResponse.ContactId);
	orderItemContainer.find('.orderItemDelete').attr('id', 'orderItemDelete_' + orderResponse.ContactId);
	orderItemContainer.find('.orderItemDelete').attr('onclick', 'DeleteOrderItem(jQuery(this))');
	if (orderResponse.IsContactInfoError) {
		orderItemContainer.find('.orderItemCosts').hide();
		orderItemContainer.find('td:not(.itemDelete)').css('background', '#E76F6F');
		orderItemContainer.find('.orderItemContactError a').attr('onclick', 'InitEditContactAddressDialogHelper(jQuery(this))');
		orderItemContainer.find('.orderItemContactError').show();
		orderItemContainer.find('.orderItemCosts').hide();
		orderItemContainer.find('.orderItemOptions').hide();
	}
	else if (orderResponse.IsCalculateError) {
		//jQuery('#orderTotals').hide();
		orderItemContainer.find('.orderItemCosts').hide();
		orderItemContainer.find('.orderItemCalcError').show();
	}
	else {
		orderItemContainer.find('.orderItemCalcError').hide();
		//jQuery('#orderTotals').show();
		orderItemContainer.find('.orderViewPricing').attr('onclick', 'ViewOrderItemPricingDialog(jQuery(this))');
		orderItemContainer.find('td:not(.itemDelete)').css('background', '#F9F9F9');
		orderItemContainer.find('.orderItemContactError').hide();
		orderItemContainer.find('.orderItemCosts').show();
		orderItemContainer.find('.orderItemOptions').show();
		orderItemContainer.find('.orderItemSubtotal').text(orderResponse.Subtotal == 0 ? '$0.00' : '$' + orderResponse.Subtotal.toFixed(2));
		orderItemContainer.find('.orderItemTax').text(orderResponse.Tax == 0 ? '$0.00' : '$' + orderResponse.Tax.toFixed(2));
		if (jQuery('#orderDocumentsBillingShippingGlobal').val().toLowerCase() == 'local') {
			orderItemContainer.find('.orderItemShipping').text("Pricing not available!");
		}
		else {
			orderItemContainer.find('.orderItemShipping').text(orderResponse.Shipping == 0 ? '$0.00' : '$' + orderResponse.Shipping.toFixed(2));
		}
		orderItemContainer.find('.orderItemSurcharge').text(orderResponse.Surcharge == 0 ? '$0.00' : '$' + orderResponse.Surcharge.toFixed(2));
		orderItemContainer.find('.orderItemTotal').text(orderResponse.Total == 0 ? '$0.00' : '$' + orderResponse.Total.toFixed(2));
	}
	if (jQuery('#orderDocumentsBillingShippingGlobal').val().toLowerCase() == 'local' && !orderResponse.IsCalculateError && !orderResponse.IsContactInfoError) {
		orderItemContainer.find('.orderItemShippingNote').show();
	}
	else {
		orderItemContainer.find('.orderItemShippingNote').hide();
	}
	var today = new Date();
	if (today.getDay() == 5) {
		jQuery('#orderItemSaturdayDelivery').closest('tr').show();
	}

	jQuery('.orderItemCalcErrorInfo').tooltip();
	CalculateOrderTotal();
}

function DeleteOrderItem(deleteButton) {
	var contactId = deleteButton.attr('id').replace('orderItemDelete_', '');
	selectedContacts.splice(selectedContacts.indexOf(contactId), 1);
	jQuery('#orderItem_' + contactId).remove();
	if (selectedContacts.length == 0) {
		OrderingBack();
	}
	else {
		delete orderArr[contactId];
		CalculateOrderTotal();
	}
}

function UpdateSelectedContacts() {
	gridMain.uncheckAll();
	for (var sc = 0; sc < selectedContacts.length; sc++) {
		if (gridMain.getRowById(selectedContacts[sc]) != null) {
			gridMain.cells(selectedContacts[sc], 0).setValue(1);
		}
	}
}

function InitEditContactAddressDialogHelper(editButton) {
	var contactId = parseInt(editButton.closest('tr').attr('id').replace('orderItem_', ''));
	InitEditContactAddressDialog(contactId);
}

var editContactAddressDialog = null;

function InitEditContactAddressDialog(contactId) {
	editContactAddressDialog = jQuery('#editContactAddressDialog');
	editContactAddressDialog.dialog({
		title: "Edit Recipient Address",
		modal: true,
		resizable: false,
		width: "auto",
		dialogClass: 'editContactAddressDialog',
		buttons: [{
			text: "Save",
			click: function () {
				//Save contact info and reload in invoice
				PanteraScript.PanteraScriptService.UpdateContactAddress(pjqSessionId, contactId, jQuery('#orderEditContactName').val(), jQuery('#orderEditCompanyName').val(), jQuery('#orderEditAddress1').val(), jQuery('#orderEditAddress2').val(), jQuery('#orderEditCity').val(), jQuery('#orderEditState').val(), jQuery('#orderEditZip').val(), jQuery('#orderEditPhone').val(), UpdateOrderHelper, onScriptError);
			}
		},
			{
				text: "Cancel",
				click: function () {
					jQuery('#editContactAddressDialog').dialog('close');
				}
			}],
		open: function (event, ui) {
			var orderItemContainer = jQuery('#orderItem_' + contactId);
			jQuery('#orderEditCompanyName').val(orderItemContainer.find('.orderItemCompanyName').text());
			jQuery('#orderEditContactName').val(orderItemContainer.find('.orderItemContactName').text());
			jQuery('#orderEditAddress1').val(orderItemContainer.find('.orderItemContactAddress1').text());
			jQuery('#orderEditAddress2').val(orderItemContainer.find('.orderItemContactAddress2').text());
			jQuery('#orderEditCity').val(orderItemContainer.find('.orderItemContactCity').text());
			jQuery('#orderEditState').val(orderItemContainer.find('.orderItemContactState').text());
			jQuery('#orderEditZip').val(orderItemContainer.find('.orderItemContactZip').text());
			jQuery('#orderEditPhone').val(orderItemContainer.find('.orderItemContactPhone').text());
			jQuery('#editContactAddressDialog').find('input, select').each(function () {
				CheckContactInfoValid(jQuery(this));
			})
		},
		close: function (event, ui) {
			jQuery('#orderEditContactName').val('');
			jQuery('#orderEditCompanyName').val('');
			jQuery('#orderEditAddress1').val('');
			jQuery('#orderEditAddress2').val('');
			jQuery('#orderEditCity').val('');
			jQuery('#orderEditState').val('');
			jQuery('#orderEditZip').val('');
			jQuery(this).css('background', 'inherit');
		}
	})
}

function CheckContactInfoValid(input) {
	if (input.attr('id') == 'orderEditZip' && input.val().trim().length < 5) {
		input.css('background', 'rgba(255, 0, 0, 0.33)');
	}
	else if (input.val().trim().length == 0 && input.attr('id') != 'orderEditAddress2') {
		input.css('background', 'rgba(255, 0, 0, 0.33)');
	}
	else {
		input.css('background', 'inherit');
	}
}

var viewOrderItemPricingDialog = null;

function ViewOrderItemPricingDialog(pricingBtn) {
	var contactId = parseInt(pricingBtn.closest('tr').attr('id').replace('orderItem_', ''));
	viewOrderItemPricingDialog = jQuery('#viewOrderItemPricingDialog');
	viewOrderItemPricingDialog.dialog({
		title: "Order Summary: " + jQuery('#orderItem_' + contactId).find('.orderItemCompanyName').text(),
		modal: true,
		resizable: false,
		width: 400,
		dialogClass: 'viewOrderItemPricingDialog',
		buttons: [
			{
				text: "Close",
				click: function () {
					jQuery('#viewOrderItemPricingDialog').dialog('close');
				}
			}],
		open: function (event, ui) {
			for (var oc = 0; oc < orderArr[contactId].OrderItems.length; oc++) {
				jQuery('#viewOrderItemPricingDialog>table>tbody').append('<tr><td>' + orderArr[contactId].OrderItems[oc].ItemName + '</td><td>' + (orderArr[contactId].OrderItems[oc].ItemCount == 0 ? 'N/A' : orderArr[contactId].OrderItems[oc].ItemCount) + '</td><td>$' + orderArr[contactId].OrderItems[oc].ItemCost.toFixed(2) + '</td></tr>');
			}
			jQuery('#orderItemPricingTotal').append('<span style="font-weight:bold;float:right;">Total: $' + orderArr[contactId].Total.toFixed(2) + '</span>');
			if (jQuery('#orderDocumentsBillingShippingGlobal').val().toLowerCase() == 'local') {
				jQuery('#viewOrderItemPricingDialog').after('<div class="orderShippingNote" style="margin:0 auto;width:90%;"><div style="font-weight:bold;text-decoration:underline;color:#cd0a0a;">Note: </div><div>Local delivery price not available!  You will be contacted by customer service with a quote upon submitting this order</div></div>');
			}
		},
		close: function (event, ui) {
			jQuery('#viewOrderItemPricingDialog>table>tbody').children('tr').children('td').remove();
			jQuery('#orderItemPricingTotal').empty();
			jQuery('.orderShippingNote').remove();
		}
	})
}

function SubmitOrder() {
	if (settings.IsRequireOrderPONumber && !validator.element('#orderDocumentsBillingPOGlobal')) {
		jQuery("#orderDocumentsBillingPOGlobal").siblings('label').children('br').remove();
		return;
	}

	var contactOrders = '';
	viewOrderItemPricingDialog = jQuery('#orderConfirmDialog');
	viewOrderItemPricingDialog.dialog({
		title: "Confirm Order",
		modal: true,
		resizable: false,
		width: 400,
		dialogClass: 'orderConfirmDialog',
		buttons: [
			{
				text: "Submit",
				click: function () {
					for (var co = 0; co < selectedContacts.length; co++) {
						if (orderArr[selectedContacts[co]] != null && !orderArr[selectedContacts[co]].IsContactInfoError) {
							var isSignatureRequired = jQuery('#orderItem_' + selectedContacts[co]).find('.orderItemSignatureRequired').prop('checked');
							var isSaturdayDelivery = jQuery('#orderSaturdayDelivery').prop('checked');
							contactOrders += selectedContacts[co] + '|' + isSignatureRequired + '|' + isSaturdayDelivery + ',';
						}
					}
					contactOrders = contactOrders.substring(0, contactOrders.length - 1);
					jQuery('.orderConfirmDialog').find('.ui-dialog-buttonpane').hide();
					jQuery('#orderConfirmDefaultText').hide();
					jQuery('#orderConfirmErrorText').closest('div').hide();
					jQuery('#orderConfirmLoading').show();
					var specQuantity = parseInt(jQuery('#orderSpecsQuantity').val());
					PanteraScript.PanteraScriptService.SubmitOrder(pjqSessionId, contactOrders, jQuery.map(selectedDrawings, function (e, key) {
						return key;
					}).join(), jQuery.map(selectedSpecs, function (e, key) {
						return key;
					}).join(), jQuery('#orderDocumentsBillingShippingGlobal').val(), jQuery('#orderDrawingsBindingType').val(), jQuery('#orderDrawingsPaperType').val(), jQuery('#orderSpecsBindingType').val(), jQuery('#orderSpecsPaperType').val(), project.ProjectId, jQuery('#orderDocumentsBillingPOGlobal').val(), jQuery('#orderDocumentsBillingDescriptionGlobal').val(), jQuery('#orderDocumentsBillingNotesGlobal').val(), false, settings.IsPaymentInfo, '', jQuery('#notifyEmailAlt').val(), parseInt(jQuery('#orderDrawingsQuantityFull').val()), specQuantity, parseInt(jQuery('#orderDrawingsQuantityHalf').val()), parseInt(jQuery('#orderCDQuantity').val()), SubmitOrderC, onScriptError);
				}
			},
			{
				text: "Back",
				click: function () {
					jQuery('#orderConfirmDialog').dialog('close');
				}
			}],
		open: function (event, ui) {
			jQuery('.orderConfirmDialog').find('.ui-icon-closethick').closest('button').remove();
			var orderConfirmErrorCounter = 0;
			for (var order in orderArr) {
				if (orderArr[order].IsContactInfoError) {
					orderConfirmErrorCounter++;
				}
			}
			jQuery("button[text='Submit']", jQuery('.orderConfirmDialog')).button('disable', false);
			if (orderConfirmErrorCounter > 0) {

				if (orderArr.length - orderConfirmErrorCounter > 0) {
					jQuery('#orderConfirmErrorText').text(orderConfirmErrorCounter + (orderConfirmErrorCounter == 1 ? ' contact has ' : ' contacts have ') + 'insufficient shipping information.  If you continue without updating ' + (orderConfirmErrorCounter == 1 ? ' it, that contact ' : ' them, those contacts ') + 'will be removed from the order!');
					jQuery('#orderConfirmErrorText').closest('div').show();
				}
				else {
					jQuery('#orderConfirmErrorText').text(orderConfirmErrorCounter + (orderConfirmErrorCounter == 1 ? ' contact has ' : ' contacts have ') + 'insufficient shipping information.  There are no valid contacts in this order.');
					jQuery('#orderConfirmErrorText').closest('div').show();
					jQuery("button[text='Submit']", jQuery('.orderConfirmDialog')).button('disable', true);
				}

			}
		},
		close: function (event, ui) {
			jQuery('#orderConfirmErrorText').text('');
			jQuery('#orderStartNew, #backToWall').hide();
			jQuery('.orderConfirmDialog').find('.ui-dialog-buttonpane').show();
			jQuery('#orderConfirmErrorText').closest('div').hide();
			jQuery('#orderConfirmNumber').text('');
			jQuery('#confirmOrderSuccess').hide();
			jQuery('#orderConfirmDefaultText').show();
		}
	})
}

function SubmitOrderC(response) {
	jQuery('#orderConfirmLoading').hide();
	jQuery('#orderStartNew, #backToWall').button();
	jQuery('#orderStartNew').on('click', function () {
		currentStep = 2;
		OrderingBack(true);
		jQuery('#orderConfirmDialog').dialog('close');
		jQuery('#orderDocumentsBillingPOGlobal').val('');
		jQuery('#orderDocumentsBillingDescriptionGlobal').val('');
		jQuery('#orderDocumentsBillingNotesGlobal').val('');
	});
	jQuery('#backToWall').on('click', function () {
		currentStep = 1;
		OrderingBack();
		jQuery('#orderConfirmDialog').dialog('close');
		jQuery('#orderDocumentsBillingPOGlobal').val('');
		jQuery('#orderDocumentsBillingDescriptionGlobal').val('');
		jQuery('#orderDocumentsBillingNotesGlobal').val('');
	});

	if (response != 0) {
		if (!settings.IsPaymentInfo) {
			var url = 'http://';
			if (window.location.hostname.startsWith('www.panteratools') || window.location.hostname.startsWith('planexpress'))
				url = 'https://';

			var orderType = 'OrderPrints';

			url = url + window.location.hostname + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLS&o=' + response + '&ot=' + orderType;
			window.location.href = url;
		}
		else {
			jQuery('#confirmOrderSuccess').show();
			jQuery('#orderStartNew, #backToWall').show();
			jQuery('#orderConfirmNumber').text(response);
		}
	}
	else {
		jQuery('#confirmOrderError').show();
		jQuery('#orderStartNew').show();
	}
}


//ADDRESS BOOK
var addressBookInit = false;
var pjqABContext = '';
var abOrderSettings = {};
var tbSearch = null;
var gridMain = null;
var abOrderSettings = {};
var treeGroupFilter = null, gridGroupFilter = null;
var selectedRows = '', lastFilter = '';
var filteredGroups = '';
var gridMainSortOrder = 'CompanyName', gridMainSortDirection = 'asc', gridMainSortIndex = 0, gridMainLastPage = 0;

function InitAddressBook() {
	addressBookInit = true;

	abOrderSettings.AddressBookContext = pjqABContext;
	abOrderSettings.Project = {ProjectName: '', City: '', StateProvince: '', PostalCode: ''};
	abOrderSettings.ProjContainer = {ProjectContainerName: '', City: '', StateProvince: '', PostalCode: ''};

	tbSearch = new dhtmlXToolbarObject("main-search");
	tbSearch.setSkin("dhx_web");
	tbSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbSearch.addText("search_label", 1, "<b>Search for:</b>");
	tbSearch.addInput('search_for', 2, '', 250);
	tbSearch.addSeparator("zip_sep", 4);
	tbSearch.addText('zip_label', 5, '<b>Zip:</b>');
	tbSearch.addInput('zip', 6, '', 75);
	tbSearch.addSeparator("radius_sep", 7);
	tbSearch.addText('radius_label', 8, '<b>Radius:</b>');
	//tbSearch.addSlider("radius", 9, 100, 0, 300, 0, "0 mi", "300 mi", "%v Miles");
	var radiusOpts = Array(Array('radius_0', 'obj', '0 Miles', ''), Array('radius_10', 'obj', '10 Miles', ''), Array('radius_15', 'obj', '15 Miles', ''), Array('radius_25', 'obj', '25 Miles', ''), Array('radius_50', 'obj', '50 Miles', ''), Array('radius_75', 'obj', '75 Miles', ''), Array('radius_100', 'obj', '100 Miles', ''), Array('radius_125', 'obj', '125 Miles', ''), Array('radius_150', 'obj', '150 Miles', ''), Array('radius_175', 'obj', '175 Miles', ''), Array('radius_200', 'obj', '200 Miles', ''), Array('radius_225', 'obj', '225 Miles', ''), Array('radius_250', 'obj', '250 Miles', ''), Array('radius_275', 'obj', '275 Miles', ''), Array('radius_300', 'obj', '300 Miles', ''));
	tbSearch.addButtonSelect("radius", 9, "0 Miles", radiusOpts, "", "");
	tbSearch.setListOptionSelected('radius', 'radius_0');

	tbSearch.addSeparator("groups_sep", 10);
	tbSearch.addButton("groups", 11, "All Trades", "", "");
	tbSearch.setItemText("groups", "All " + settings.GroupLabel);

	tbSearch.addSeparator("search_sep", 12);
	tbSearch.addButton("search", 13, "Search", "action_search.gif", "");
	tbSearch.addSeparator("clear_sep", 16);
	tbSearch.addButton("clear", 17, "Clear Search", "cancel_search.gif", "");
	tbSearch.addSeparator("left_sep", 18);

	tbSearch.addSpacer("left_sep");


	jQuery('input.inp').keypress(function (event) {
		if (event.which == 13) {
			event.preventDefault();
			InitGridAB();
		}
	});

	tbSearch.attachEvent("onClick", function (id) {
		if (id.startsWith('radius')) {
			if (id.indexOf('_') > 0) {
				var label = id.substring(id.indexOf('_') + 1) + ' Miles';
				tbSearch.setItemText('radius', label);
			}
		}
		else if (id == 'search') {
			InitGridAB();
		}
		else if (id == 'clear') {
			tbSearch.setValue('search_for', '', false);
			tbSearch.setValue('zip', '', false);
			tbSearch.setListOptionSelected('radius', 'radius_0');
			tbSearch.setItemText('radius', '0 Miles');
			tbSearch.setItemText("groups", "All " + abOrderSettings.GroupLabel);
			filteredGroups = '';
			if (abOrderSettings.GroupLevel > 0 && treeGroupFilter != null) {
				treeGroupFilter.setSubChecked('0', false);
				treeGroupFilter.setCheck('NONE', false);

			}
			else if (gridGroupFilter != null)
				gridGroupFilter.setCheckedRows(0, 0);

			tbSearch.enableItem('search_for');
			tbSearch.enableItem('zip');
			tbSearch.enableItem('radius');
			tbSearch.enableItem('groups');
			tbSearch.enableItem('search');

			InitGridAB();
		}
		else if (id == 'groups') {
			if (abOrderSettings.GroupLevel > 0 && treeGroupFilter == null) {
				treeGroupFilter = new dhtmlXTreeObject("group-filter", "100%", "100%", 0);
				treeGroupFilter.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
				treeGroupFilter.enableCheckBoxes(1);
				treeGroupFilter.enableMultiLineItems("300px");
				treeGroupFilter.enableTreeLines(false);
				treeGroupFilter.enableTreeImages(false);
				//treeGroupFilter.setOnClickHandler(treeContactGroupsclick);
				treeGroupFilter.setDataMode('json');
				treeGroupFilter.loadJSON('/DesktopModules/PJQAddressBook/GetGroupTree.aspx?sessionid=' + pjqSessionId + '&nogroup=1&x=' + (new Date).getTime(), function () {
					jQuery('#group-filter div table tbody tr td table tbody tr td img').first().parent().css('display', 'none');
					jQuery('#group-filter div table tbody tr td table tbody tr td img').first().parent().next().css('padding-left', '2px');
				});
			}
			else if (abOrderSettings.GroupLevel == 0 && gridGroupFilter == null) {
				gridGroupFilter = new dhtmlXGridObject('group-filter');
				gridGroupFilter.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');//path to images required by grid
				gridGroupFilter.enableMultiline(true);
				gridGroupFilter.setSkin(pjqGridTheme);
				gridGroupFilter.setHeader("&nbsp;," + abOrderSettings.GroupLabel + ",Contacts");
				gridGroupFilter.setInitWidthsP("6,80,14");
				gridGroupFilter.setColAlign("center,left,center");
				gridGroupFilter.setColTypes("ch,ro,ro");
				gridGroupFilter.setColSorting("na,na,na");
				gridGroupFilter.enableTooltips("false,true,false");
				gridGroupFilter.enableAutoHeight(true, 450);
				gridGroupFilter.enableAutoWidth(true);
				gridGroupFilter.init();
				gridGroupFilter.loadXML('/DesktopModules/PJQAddressBook/GetGroupList.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime());
			}

			var dlg = jQuery("#dialog-filter-groups").dialog({
				resizable: false,
				height: 600,
				width: 800,
				title: 'Filter ' + abOrderSettings.GroupLabel,
				modal: true,
				draggable: false,
				buttons: {
					"Check All": function () {
						if (abOrderSettings.GroupLevel > 0) {
							treeGroupFilter.setSubChecked('0', true);
							treeGroupFilter.setCheck('NONE', true);
						}
						else
							gridGroupFilter.setCheckedRows(0, 1);
					},
					"Clear All": function () {
						if (abOrderSettings.GroupLevel > 0) {
							treeGroupFilter.setSubChecked('0', false);
							treeGroupFilter.setCheck('NONE', false);
						}
						else
							gridGroupFilter.setCheckedRows(0, 0);
					},
					"Filter": function () {
						var itemCount;
						if (abOrderSettings.GroupLevel > 0) {
							filteredGroups = treeGroupFilter.getAllChecked().replace('NONE', '0');
							var checkedItems = filteredGroups.split(',');
							itemCount = checkedItems.length;
							if (itemCount == 1 && checkedItems[0].length == 0)
								itemCount = 0;

						}
						else {
							filteredGroups = gridGroupFilter.getCheckedRows(0);
							itemCount = filteredGroups.split(',').length;
							if (filteredGroups.length == 0)
								itemCount = 0;
						}

						if (itemCount == 0)
							tbSearch.setItemText("groups", "All " + abOrderSettings.GroupLabel);
						else if (itemCount == 1)
							tbSearch.setItemText("groups", "1 " + abOrderSettings.GroupLabel);
						else if (itemCount > 1)
							tbSearch.setItemText("groups", itemCount.toString() + " " + abOrderSettings.GroupLabel);

						InitGridAB();
						$(this).dialog('close');
					}
				}
			});

		}
	});

	gridMainSortIndex = 0;

	var parts = pjqFMContact;
	parts = parts.split(',');
	parts = parts[gridMainSortIndex].split('|')[3];
	if (parts == 'na') {
		gridMainSortIndex++;
	}


	PanteraScript.PanteraScriptService.GetAddressBookSettings(pjqSessionId, GetABSettingsC, onScriptError);
}

function EnableToolbars(enabled) {
	if (tbSearch != null) {
		if (enabled) {
			tbSearch.enableItem('search_for');
			tbSearch.enableItem('zip');
			tbSearch.enableItem('radius');
			tbSearch.enableItem('groups');
			tbSearch.enableItem('search');
			tbSearch.enableItem('clear');
		}
		else {
			tbSearch.disableItem('search_for');
			tbSearch.disableItem('zip');
			tbSearch.disableItem('radius');
			tbSearch.disableItem('groups');
			tbSearch.disableItem('search');
			tbSearch.disableItem('clear');
		}
	}
}

function GetABSettingsC(response) {
	abOrderSettings = jQuery.parseJSON(response);
	var verb = 'View';
	InitGrid();
}


function InitGrid() {
	gridMainSortDirection = 'asc';
	gridMainSortIndex = 0;

	var parts = pjqFMContact;
	parts = parts.split(',');
	parts = parts[gridMainSortIndex].split('|')[3];

	gridMainSortIndex = 0;

	if (parts == 'na') {
		gridMainSortIndex++;
	}

	InitGridAB('contact');
}

function GridResized() {
	//jQuery('#grid-main').css('height','100%');
	gridMain.setSizes();
}

function InitGridAB() {
	gridMain = new dhtmlXGridObject('grid-main');
	gridMain.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');//path to images required by grid
	gridMain.enableMultiline(true);
	gridMain.setSkin(pjqGridTheme);
	jQuery('#grid-main-paging').removeClass('pjq-hidden');
	gridMain.enablePaging(true, abOrderSettings.RowsPerPage, 3, "grid-main-paging", true);
	gridMain.setPagingSkin("toolbar", 'dhx_web');

	gridMain.attachEvent("onCheck", function (id, ind, state) {
		CheckCanContinue();
		if (state && selectedContacts.indexOf(id) == -1) {
			selectedContacts.push(id);
		}
		else if (!state && selectedContacts.indexOf(id) != -1) {
			selectedContacts.splice(selectedContacts.indexOf(id), 1);
		}
	});

	gridMain.attachEvent("onBeforePageChanged", function () {
		if (!this.getRowsNum())
			return false;
		return true;
	});

	gridMain.attachEvent("onPageChanged", function (ind, fInd, lInd) {
		jQuery(window).scrollTop(0);
		return true;
	});

	gridMain.sortRows = function (col, type, order) {
	};

	/*
	dhtmlXGridObject.prototype._in_header_master_checkbox_rec=function(a,b,c){a.innerHTML=c[0]+"<input type='checkbox' id='project-docs-selectall' />"+c[1];var d=this;a.getElementsByTagName("input")[0].onclick=function(a){d._build_m_order();var c=d._m_order?d._m_order[b]:b,g=this.checked?1:0;d.forEachRowA(function(a){var b=this.cells(a,c);if(b.isCheckbox() && !b.isDisabled())b.setValue(g),b.cell.wasChanged=!0;this.callEvent("onEditCell",[1,a,c,g]);this.callEvent("onCheckbox",[a,c,g])});
	  //DO STUFF HERE
	  (a||event).cancelBubble=!0;}
	};
	*/

	jQuery('#grid-main').css('width', '100%');
	gridMain.enableAutoHeight(true);
	//gridMain.enableAutoWidth(true);

	gridMain.attachEvent("onXLS", function (grid_obj) {
		jQuery('.contactsGridLoading').show();
	});
	gridMain.attachEvent("onXLE", function (grid_obj) {
		jQuery('.contactsGridLoading').hide();
		UpdateSelectedContacts();
		gridMain.forEachRow(function (id) {
			var i = 0;
			var counter = 0;
			if (gridMain.getUserData(id, 'IsPrimaryContact') == 'true') {
				jQuery(gridMain.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
			}
			if (gridMain.getUserData(id, 'IsBlacklisted') == 'true') {
				gridMain.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
			}
			else {
				var i = 0, j = 0, k = 0, selectedCount = 0;
				for (i = 0; i < abOrderSettings.DisabledRowsCount; i++) {
					for (j = 0; j < abOrderSettings.DisabledRows[i].Cs.length; j++) {
						if (abOrderSettings.DisabledRows[i].Cs[j].C == parseInt(id)) {
							for (k = 0; k < abOrderSettings.DisabledRows[i].Cs[j].Gs.length; k++) {
								if (abOrderSettings.DisabledRows[i].Cs[j].Gs[k].Sel || abOrderSettings.DisabledRows[i].Cs[j].Gs[k].G == 0) {
									selectedCount += 1;
								}
							}
							if (selectedCount > 0 && selectedCount == abOrderSettings.DisabledRows[i].Cs[j].Gs.length) {
								gridMain.cells(id, 0).setDisabled(true);
								gridMain.cells(id, 0).setChecked(true);
								var subgrid = gridMain.cells(id, 1).getSubGrid();
								if (subgrid)
									subgrid.forEachRow(function (id2) {
										for (k = 0; k < abOrderSettings.DisabledRows[i].Cs[j].Gs.length; k++) {
											if (abOrderSettings.DisabledRows[i].Cs[j].Gs[k].G == subgrid.getUserData(id2, "GroupId")) {
												subgrid.cells(id2, 0).setChecked(true);
											}
										}
									});
							}
							else if (selectedCount > 0) {
								gridMain.cells(id, 0).setValue('2');
							}
						}
					}
				}
			}
		})
	});
	gridMain.init();
	dhtmlxEvent(window, "resize", function () {
		jQuery('#grid-main, #grid-main div table').css('width', '100%');
		jQuery('#grid-main div table tbody tr th').css('width', '');
		jQuery('#edit-contact-groups, #edit-contact-regions, #grid-contacts').css('width', '100%');
		jQuery('#edit-contact-groups div table, #edit-contact-regions div table, #grid-contacts div table').css('width', '100%');
		jQuery('#edit-contact-groups div table tbody tr th, #edit-contact-regions div table tbody tr th, #grid-contacts div table tbody tr th').css('width', '');
		gridMain.setSizes();
	});

	gridMain.attachEvent("onCheck", function (rId, cInd, state) {


		return true;
	});

	gridMain.attachEvent("onBeforeSorting", function (ind, type, direction) {

		gridMain.setSortImgState(true, ind, direction);
		if (type == 'server') {
			gridMain.clearAll(true);
			var parts;
			parts = pjqFMContact;
			parts = parts.split(',');
			parts = parts[ind].split('|')[0];

			gridMainSortIndex = ind;
			gridMainSortOrder = parts;


			gridMainSortDirection = direction;
			SetABSPc();
			//return false;
		}
		//else
		return true;
	});

	gridMainSortOrder = 'CompanyName';
	gridMainSortDirection = 'asc';

	var searchFor = tbSearch.getValue('search_for');
	if (searchFor.length <= 15 && DigitsOnly(searchFor).length == 10) {
		searchFor = DigitsOnly(searchFor);
	}
	var radius = tbSearch.getListOptionSelected('radius');
	radius = radius.substring(radius.indexOf('_') + 1);
	PanteraScript.PanteraScriptService.SetAddressBookSearchParameters(pjqSessionId, 'contact', searchFor, 1, tbSearch.getValue('zip'), parseInt(radius), filteredGroups, 1, '', '', SetABSPc, onScriptError);

}

function DigitsOnly(input) {
	var result = '';
	var i = 0;
	for (i = 0; i < input.length; i++) {
		result += jQuery.isNumeric(input[i]) ? input[i] : '';
	}

	return result;
}

function SetABSPc() {
	var xmlFile = '';

	xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetContacts' + '.aspx?view=contact&sessionId=' + pjqSessionId + '&o=' + gridMainSortOrder + '&d=' + gridMainSortDirection + '&cb=1' + '&x=' + (new Date).getTime();

	gridMain.loadXML(xmlFile, function () {
		gridMain.forEachRow(function (id) {
			if (gridMain.getUserData(id, 'IsPrimaryContact') == 'true')
				jQuery(gridMain.cells(id, 0).cell.parentNode).addClass('pjq-primary-contact');
			if (gridMain.getUserData(id, 'IsBlacklisted') == 'true') {
				gridMain.setRowTextStyle(id, "color: gray; font-style: italic; text-decoration: line-through;");
			}
		});

		gridMain.setSortImgState(true, gridMainSortIndex, gridMainSortDirection);

		if (gridMainLastPage > 1) {
			gridMain.changePageRelative(gridMainLastPage - 1);
			gridMainLastPage = 0;
		}
		else if (gridMainLastPage == 1) {
			gridMainLastPage = 0;
		}

		setTimeout(GridResized, 500);
	});

}

function formatDate(jsonDate) {
	if (!jsonDate)
		return '';
	var date = new Date(parseInt(jsonDate.substr(6)));
	return dateFormat(date, 'mm/dd/yyyy');
}

function IsInArray(val, arr) {
	return ($.inArray(val, arr) != -1);
}

function AddIfMissing(arr, val) {
	if (!val)
		return;

	var data = val.split(',');
	for (var j = 0; j < data.length; j++) {
		var index = -1;
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] == parseInt(data[j]))
				index = i;
		}
		if (index == -1)
			arr.push(parseInt(data[j]));
	}

}

function RemoveIfPresent(arr, val) {
	if (!val)
		return;

	var data = val.split(',');
	for (var j = 0; j < data.length; j++) {
		var index = -1;
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] == parseInt(data[j]))
				index = i;
		}
		if (index != -1)
			arr.splice(index, 1);
	}
}